import React, { Component, Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import Parse from "parse";
import { Input, Select, Label, Spinner } from "../../Common/Forms";
import TextareaAutosize from "react-textarea-autosize";
import SearchItem from "./SearchItem";
import moment from "moment";
import UseTestMembers from "./UseTestMembers";
import {
  fetchOrganization,
  createOrganization,
  updateOrganizationName,
  updateOrganizationProfile,
  addMembersToOrganization,
  addGuestsToOrganization,
  removeMembersFromOrganization,
  removeGuestsFromOrganization,
  addAdminsToOrganization,
  removeAdminsFromOrganization,
  fetchOrganizationGroups,
  addGroupsToOrganization,
  removeGroupsFromOrganization,
  addOrgEmail,
  removeOrgEmail,
  setOrganizationRole,
  patientHubs,
  modifyOrganization,
} from "../../../actions/SessionAction";
import AddMemberModal from "./AddMemberModal";
import AddGuestModal from "../../Conversation/Setting/AddGuestModal";
import CreatePatient from "../PatientTab/CreatePatient";
import { createThread } from "../../../actions/ThreadAction";
import { fetchSubscriber } from "../../../actions/RevenueCatAction";
import { organizationDashboard } from "../../../actions/CorporateAction";
import _ from "lodash";
import Logo from "../../../assets/images/logo-blue.png";
import { PieChart, Pie, Legend, Tooltip, ResponsiveContainer, Cell } from "recharts";
import { toast, ToastContainer } from "react-toastify";
import Notify from "../../Common/Notify";
import "./CorporateSetting.css";
import { ThemeProvider } from "styled-components";

const $ = window.$;
const defaultImage = require("../../../assets/images/group-default.png");

//Test data
const { testMembers, city, state, country, orgRole } = UseTestMembers() || [];
var filter = "";
var count = 0;
var term = "";

export class CorporateSetting extends Component {
  constructor() {
    super();

    this.state = {
      // isUploading: false,
      willEditName: false,
      nameIsUpdating: false,
      failedToUpdateName: false,
      // willUpload: false,
      // isUploading: false,
      // profilePictureURL: defaultImage,
      openAddMemberModal: false,
      openCreatePatientModal: false,
      isFetchingGroups: true,
      isFetchingGroupsStatus: "Error",
      // isSearching: false,
      // typeValue: "",
      errorAddMember: false,
      errorAddMemberMessage: "",
      // newOrgEmail: "",
      // addingOrgEmail: false,
      filterMember: false,
      memberFilter: true,

      members: testMembers,

      tab: "dashboard",
      filterPatient: "all",
      filterSubs: "subscription",

      orgDashboard: {},
      orgHubs: {},
      address: {},
      membersFilter: "all",
      searchKey: "",
    };

    this.selectTab = this.selectTab.bind(this);
    this.removeMember = this.removeMember.bind(this);
    this.removeGuest = this.removeGuest.bind(this);
    this.assignAdmin = this.assignAdmin.bind(this);
    this.removeAdmin = this.removeAdmin.bind(this);
    this.updateCorporateName = this.updateCorporateName.bind(this);
    this.openAddMemberModal = this.openAddMemberModal.bind(this);
    this.openAddGuestModal = this.openAddGuestModal.bind(this);
    this.openCreatePatientModal = this.openCreatePatientModal.bind(this);
    this.handleUpdateCorporateSetting = this.handleUpdateCorporateSetting.bind(this);
  }

  componentDidMount() {
    this.props.fetchOrganization().then((org) => {
      this.setState({ address: org });
    });
    this.props.fetchSubscriber();
    this.props.patientHubs().then((hubs) => {
      this.setState({
        orgHubs: hubs,
      });
    });
    this.props.organizationDashboard().then((org) => {
      this.setState({ orgDashboard: org });
    });
  }

  componentDidUpdate() {}

  getSnapshotBeforeUpdate(prevProps, prevState) {
    if (prevState.tab !== this.state.tab) {
    }
    if (prevState.filterPatient !== this.state.filterPatient) {
    }
    if (prevState.filterSubs !== this.state.filterSubs) {
    }
  }

  openFileImage() {
    $(this.refs.corporateImage).trigger("click");
  }

  fetchOrgGroups() {
    if (this.props.organizationFetchStatus === "SUCCESS" && this.props.organization.objectId) {
      this.props
        .fetchOrganizationGroups(this.props.organization.owner.objectId)
        .then(() => {
          this.setState({
            isFetchingGroups: false,
          });
        })
        .catch(() => {
          this.setState({
            isFetchingGroups: false,
            isFetchingGroupsStatus: "Error",
          });
        });
    }
  }

  openCorporateSubscriptionView() {
    const { activeThread } = this.props;
    const filesUrl = [window.location.origin, "/corporate-subscription"].join("");
    window.open(filesUrl, "Corporate Subscription");
  }

  openHubChartLandingPageView() {
    const { activeThread } = this.props;
    const filesUrl = [window.location.origin, "/home"].join("");
    window.open(filesUrl, "Home");
  }

  openAddMemberModal() {
    this.setState({
      openAddMemberModal: true,
      errorAddMember: false,
    });
  }

  openAddGuestModal() {
    this.setState({
      openAddGuestModal: true,
      errorAddMember: false,
    });
  }

  closeAddMemberModal() {
    this.setState({
      openAddMemberModal: false,
    });
  }

  closeAddGuestModal() {
    this.setState({
      openAddGuestModal: false,
    });
  }

  openCreatePatientModal() {
    this.setState({
      openCreatePatientModal: true,
    });
  }

  closeCreatePatientModal() {
    this.setState({
      openCreatePatientModal: false,
    });
  }

  setFilter(filter) {
    this.setState({
      membersFilter: filter,
    });
  }

  addMember(user) {
    this.props
      .addMembersToOrganization([user])
      .then(() => {
        this.closeAddMemberModal();
      })
      .catch((message) => {
        if (message === "One or more users cannot be added because they are already members of another organization.") {
          Notify.errorWithTitle(
            "Failed to add members",
            "One or more users are already members of another organization"
          );
        } else if (message === "One or more users cannot be added because they are not using a corporate email.") {
          Notify.errorWithTitle("Failed to add members", "One or more users are not using a corporate email");
        } else {
          Notify.error("We're having problem right now, please try again later.");
        }
      });
  }

  assignAdmin(member) {
    this.props.addAdminsToOrganization(member.user);
  }

  removeMember(objectId) {
    this.props.removeMembersFromOrganization(objectId);
  }

  removeGuest(objectId) {
    this.props.removeGuestsFromOrganization(objectId);
  }

  removeAdmin(member) {
    this.props.removeAdminsFromOrganization(member.user.objectId);
  }

  updateCorporateName(corporateName) {
    //e.preventDefault();
    //let corporateName = this.refs.corporateName.value;
    // console.log(corporateName);

    if (corporateName === "" || this.props.organization.name === corporateName) {
      this.setState({
        nameIsUpdating: false,
        willEditName: false,
        failedToUpdateName: false,
      });
      return;
    }

    this.setState({
      nameIsUpdating: true,
    });

    let self = this;

    this.props
      .updateOrganizationName(corporateName, this.props.organization.objectId)
      .then(() => {
        self.setState({
          nameIsUpdating: false,
          willEditName: false,
          failedToUpdateName: false,
        });
      })
      .catch((error) => {
        self.setState({
          failedToUpdateName: true,
          nameIsUpdating: false,
          willEditName: false,
        });
      });
  }

  handleUpdateCorporateSetting(e) {
    e.preventDefault();

    let corporate = {
      corporateName: this.refs.corporateName.value,
      business_address1: this.refs.corporateAdd1.value,
      business_address2: this.refs.corporateAdd2.value,
      city: this.state.address.city || "",
      state: this.state.address.state || "",
      country: this.state.address.country || "",
      postal_code: this.refs.corporatePostal.value,
    };

    this.props.modifyOrganization(corporate);
  }

  handleUpdateOrgRole(data, strRole) {
    this.props.setOrganizationRole({
      data,
      organizations: this.props.organization,
      strRole: strRole,
    });
  }

  selectTab(tab) {
    var x = document.getElementById("corporateDash");
    var y = document.getElementById("corporateSett");
    var z = document.getElementById("corporateMem");

    x.style.display = tab == "dashboard" ? "block" : "none";
    y.style.display = tab == "setting" ? "block" : "none";
    z.style.display = tab == "member" ? "block" : "none";
  }

  showSettingNavbar() {
    document.getElementById("settingNavbar").style.width = "250px";
    document.getElementById("settingNavbar").style.zIndex = 1;
    document.getElementById("settingNavbar").style.display = "block";
  }

  hideSettingNavbar() {
    document.getElementById("settingNavbar").style.width = 0;
    document.getElementById("settingNavbar").style.zIndex = 0;
    document.getElementById("settingNavbar").style.display = "none";
  }

  tempActionHandler(link) {
    const content = (
      <span>
        <i className="fas fa-exclamation-circle mr-1"></i>
        Go to {link}
      </span>
    );
    toast.info(content, {
      position: "top-right",
      className: "toast-base-main",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      closeButton: false,
      pauseOnHover: true,
    });
  }

  _renderLayout() {
    let notesPast = this.state.orgDashboard.notes_past_6_months || 0;
    let noteDraft = this.state.orgDashboard.notes || 0;
    let searchKey = this.state.searchKey || "";
    const orgHubs = this.state.orgHubs.hubs;

    let hubActive = this.state.orgDashboard.patient_hubs || 0;
    let hubInactive = 0 || 0;

    if (this.props.organizationFetchStatus === "SUCCESS") {
      if (this.props.organization.objectId) {
        const organization = this.props.organization;
        const currentUser = Parse.User.current();
        let isOwner = this.props.organization.owner.objectId === currentUser.id;

        let tempAdminstrators = this.props.organization.administrators || [];
        let tempOwner = this.props.organization.administrators || [];
        let tempMembers = this.props.organization.members || [];
        let tempPatients = this.props.organizationGroups || [];
        let tempGuests = this.props.organization.guests || [];
        let allMembers = [...tempAdminstrators, ...tempMembers, ...tempGuests];
        const { owner } = this.props.organization;
        // const { administrators, members, guest} = this.state.orgDashboard.corporate_members;

        const allItems = [
          ...tempAdminstrators
            .filter((i) => i.objectId !== owner.objectId)
            .map((i) => ({
              ...i,
              orgObjectId: this.props.organization.objectId,
              userObjectId: i.objectId,
              source: "admin",
            })),

          ...tempMembers
            .filter((i) => i.objectId !== owner.objectId)
            .map((i) => ({
              ...i,
              orgObjectId: this.props.organization.objectId,
              userObjectId: i.objectId,
              source: "member",
            })),

          ...tempGuests
            .filter((i) => i.objectId !== owner.objectId)
            .map((i) => ({
              ...i,
              orgObjectId: this.props.organization.objectId,
              userObjectId: i.objectId,
              source: "guest",
            })),
        ];
        // if (i.objectId != owner.objectId)
        const filteredItems =
          searchKey === ""
            ? this.state.membersFilter === "all"
              ? allItems
              : allItems.filter((i) => i.source === this.state.membersFilter)
            : allItems.filter(function(member) {
                return member.displayName.toLowerCase().includes(searchKey.toLowerCase());
              });

        const filteredHubs =
          searchKey === ""
            ? this.state.membersFilter === "all"
              ? orgHubs
              : orgHubs.filter((i) => i.source === this.state.filterPatient)
            : orgHubs.filter(function(hubs) {
                return hubs.name.toLowerCase().includes(searchKey.toLowerCase());
              });

        let userObject = JSON.stringify(Parse.User.current().toJSON()); // dummy data
        userObject = JSON.parse(userObject);

        let defaultImageURL = require("../../../assets/images/default.png");
        let imageURL = require("../../../assets/images/default.png");
        if (owner.picture) {
          if (owner.picture.url) {
            imageURL = owner.picture.url;
          }
        }

        let statusStyle = {
          padding: "0",
          fontSize: "12px",
          fontWeight: "500",
          color: "rgb(95, 93, 93)",
          whiteSpace: "pre-wrap",
        };

        const containerStyles = {
          position: "relative",
          height: "100%",
          overflowY: "auto",
        };

        const {
          firstName,
          lastName,
          dob,
          pending,
          allowCorporateAccess,
          is_valid_date = true,
          memberFilter,
          members,
        } = this.state;

        const isQuantifiable = false;
        const address = this.state.address || {};

        const pie_colors = ["#2194f3", "#b3cee8"];
        const notes_posted = [
          { name: "Posted", value: notesPast },
          { name: "Draft", value: noteDraft },
        ];
        const active_hubs = [
          { name: "Active", value: hubActive },
          { name: "Inactive", value: 0 },
        ];
        //console.log(members);

        const notes = (this.state.orgDashboard.notes_past_6_months / this.state.orgDashboard.notes) * 100;
        const hubs = (0 / this.state.orgDashboard.patient_hubs) * 100;
        const pieNotes = notes.toFixed(2); // returns a string
        const pieHubs = hubs.toFixed(2); // returns a string

        return (
          <div className="corporate-account-container">
            <div className="corporate-account-sidebar">
              {/* <div className="navbar-logo" onClick={(e) => {this.showSettingNavbar()}}>
                <img
                  className="d-none d-sm-inline"
                  width="50"
                  height="50"
                  src={Logo}
                  alt="H"
                  style={{zIndex:0}}
                />
                <div className="Menu-Icon-Container">
                  <i className="fas fa-bars"></i>
                </div>
              </div> */}
              <div className="sidebar-header">
                <img className="d-none d-sm-inline" width="50" height="50" src={Logo} alt="H" />
                <span
                  className="hc-primary-text d-none d-md-inline"
                  style={{ fontWeight: "500", fontSize: 22, color: "#2c2d2d !important" }}
                >
                  HUBCHART
                </span>
                {/* <i className="fas fa-times fa-fw" style={{float:'right'}} onClick={(e) => {this.hideSettingNavbar()}}></i> */}
              </div>
              <div className="sidebar-header-2">Corporate Organization</div>
              <div className="sidebar-action">
                <p
                  onClick={() => this.setState({ tab: "dashboard" })}
                  className={`${this.state.tab === "dashboard" ? "sidebar-active" : ""}`}
                >
                  <i className="fas fa-solid fa-list-ul"></i>
                  Dashboard
                </p>
                <p
                  onClick={() => this.setState({ tab: "setting" })}
                  className={`${this.state.tab === "setting" ? "sidebar-active" : ""}`}
                >
                  <i className="fa fa-sharp fa-solid fa-gear"></i>
                  Settings
                </p>
                <p
                  onClick={() => this.setState({ tab: "members" })}
                  className={`${this.state.tab === "members" ? "sidebar-active" : ""}`}
                >
                  <i className="fas fa-solid fa-users"></i>
                  Members
                </p>
                <p
                  onClick={() => this.setState({ tab: "patientHub" })}
                  className={`${this.state.tab === "patientHub" ? "sidebar-active" : ""}`}
                >
                  <i className="fa fa-notes-medical"></i>
                  Patient Hubs
                </p>
                <p
                  onClick={() => this.setState({ tab: "subscription" })}
                  className={`${this.state.tab === "subscription" ? "sidebar-active" : ""}`}
                >
                  <i className="fas fa-shard fa-solid fa-briefcase"></i>
                  Subscription
                </p>
              </div>
            </div>
            <div className="corporate-account-main">
              {this.state.tab === "dashboard" && (
                <div className="corporate-dashboard">
                  <div style={{ marginTop: "auto" }}>
                    <div className="main-sub-header">Welcome back, {this.props.organization.owner.displayName}</div>
                    <small>Here's what's going on with your Organization</small>
                  </div>
                  <div className="corporate-dash-charts">
                    <div>
                      <div className="" style={{ width: "100%", height: "100%" }}>
                        <ResponsiveContainer>
                          <PieChart>
                            <Pie
                              dataKey="value"
                              data={notes_posted}
                              cx="50%"
                              cy="55%"
                              startAngle={-90}
                              endAngle={270}
                              innerRadius={35}
                              outerRadius={50}
                            >
                              {notes_posted.map((entry, index) => (
                                <Cell
                                  key={index}
                                  className="pie-cell"
                                  fill={pie_colors[index % pie_colors.length]}
                                  onClick={(e) => {
                                    this.tempActionHandler(entry.name + " notes page");
                                  }}
                                />
                              ))}
                            </Pie>
                            <text x="1%" y="10%" style={{ fontSize: 14, fontWeight: "600", color: "#2c2d2d" }}>
                              Notes Posted
                            </text>
                            <text x="60%" y="10%" style={{ fontSize: 14, fontWeight: "600", fill: "#2194f3" }}>
                              {this.state.orgDashboard.notes_past_6_months
                                ? this.state.orgDashboard.notes_past_6_months
                                : 0}{" "}
                              /&nbsp;
                              {this.state.orgDashboard.notes ? this.state.orgDashboard.notes : 0}
                            </text>
                            <text
                              x="42%"
                              y="58%"
                              style={{
                                fontSize: 14,
                                fontWeight: "500",
                                fill: "#2194f3",
                                fontStyle: "italic",
                              }}
                            >
                              {pieNotes}%
                            </text>
                            <Tooltip />
                          </PieChart>
                        </ResponsiveContainer>
                      </div>
                      <p className="italic-desc">Notes posted in the past 6 months</p>
                    </div>
                    <div>
                      <div className="" style={{ width: "100%", height: "100%" }}>
                        <ResponsiveContainer>
                          <PieChart>
                            <Pie
                              dataKey="value"
                              data={active_hubs}
                              cx="50%"
                              cy="55%"
                              startAngle={-90}
                              endAngle={270}
                              innerRadius={35}
                              outerRadius={50}
                            >
                              {active_hubs.map((entry, index) => (
                                <Cell
                                  key={index}
                                  className="pie-cell"
                                  fill={pie_colors[index % pie_colors.length]}
                                  onClick={(e) => {
                                    this.tempActionHandler(entry.name + " notes page");
                                  }}
                                />
                              ))}
                            </Pie>
                            <text x="1%" y="10%" style={{ fontSize: 14, fontWeight: "700", color: "#2c2d2d" }}>
                              Inactive Hubs
                            </text>
                            <text x="60%" y="10%" style={{ fontSize: 14, fontWeight: "700", fill: "#2194f3" }}>
                              {hubInactive}
                              &nbsp;/&nbsp;
                              {hubActive}
                            </text>
                            <text
                              x="42%"
                              y="58%"
                              style={{
                                fontSize: 14,
                                fontWeight: "500",
                                fill: "#2194f3",
                                fontStyle: "italic",
                              }}
                            >
                              {pieHubs}%
                            </text>
                            <Tooltip />
                          </PieChart>
                        </ResponsiveContainer>
                      </div>
                      <p className="italic-desc">Hubs with NO activity in the last 6 months</p>
                    </div>
                    <div></div>
                  </div>
                  <div className="row-3">
                    <div className="border-0" style={{ background: "#f2f7ff", padding: "10px" }}>
                      <div className="corporate-total-members-header">
                        <div className="corporate-sub-header-3">Corporate members</div>
                        <i className="fas fa-arrow-right"></i>
                      </div>
                      <div className="corporate-total-members">
                        <i className="fas fa-circle" style={{ color: "red" }}></i>
                        <div>Administrators</div>
                        <div className="text-right font-bold text-gray-900">
                          {this.state.orgDashboard.corporate_members
                            ? this.state.orgDashboard.corporate_members.administrators
                            : 0}
                        </div>
                        <i className="fas fa-circle" style={{ color: "#2194f3" }}></i>
                        <div>Members</div>
                        <div className="text-right font-bold text-gray-900">
                          {this.state.orgDashboard.corporate_members
                            ? this.state.orgDashboard.corporate_members.members
                            : 0}
                        </div>
                        <i className="fas fa-circle" style={{ color: "grey" }}></i>
                        <div>Guests</div>
                        <div className="text-right font-bold text-gray-900">
                          {this.state.orgDashboard.corporate_members
                            ? this.state.orgDashboard.corporate_members.guests
                            : 0}
                        </div>
                      </div>
                    </div>
                    <div></div>
                  </div>
                  <div>
                    <p style={{ color: "#2c2d2d" }}>Things to do:</p>
                  </div>
                  <div class="row-5">
                    {/* onClick={(e) => {this.tempActionHandler(" Setting page") */}
                    <div className="corporate-todo">
                      <div className="tree">
                        <div className="node-check fas fa-check fa-xs"></div>
                        <div className="node"></div>
                        <div className="node"></div>
                        <div className="fas fa-arrow-right corporate-arrows"></div>
                      </div>
                      <span
                        className="cursor-pointer"
                        onClick={(e) => {
                          this.tempActionHandler(" Setting page");
                        }}
                      >
                        <p>Complete your Organization information</p>
                        <small className="corporate-todo-desc">
                          To make the most of our platform, we suggest completing your organization's information. Its
                          vital for establishing credibility and trust with patients, streamlining team workflows, and
                          personalizing the patient experience.
                        </small>
                      </span>
                    </div>
                    <div className="corporate-todo">
                      <div className="tree">
                        <div className="node"></div>
                        <div className="node-check fas fa-check fa-xs"></div>
                        <div className="node"></div>
                        <div className="fas fa-arrow-right corporate-arrows"></div>
                      </div>
                      <span
                        className="cursor-pointer"
                        onClick={(e) => {
                          this.tempActionHandler(" Setting page");
                        }}
                      >
                        <p>Add members to your organization</p>
                        <small className="corporate-todo-desc">
                          By assembling a collaborative healthcare team, you can deliver comprehensive care and improve
                          patient outcomes. Adding team members fosters collaboration, expands expertise, and enhances
                          communication within your organization.
                        </small>
                      </span>
                    </div>
                    <div className="corporate-todo">
                      <div className="tree">
                        <div className="node"></div>
                        <div className="node"></div>
                        <div className="node-check fas fa-check fa-xs"></div>
                        <div className="fas fa-arrow-right corporate-arrows"></div>
                      </div>
                      <span
                        className="cursor-pointer"
                        onClick={(e) => {
                          this.tempActionHandler(" Setting page");
                        }}
                      >
                        <p>Create a patient hub</p>
                        <small className="corporate-todo-desc">
                          Create a patient hub for each individual under your care. A patient hub serves as a
                          centralized repository, housing vital information such as medical charts, progress notes,
                          medication orders, and chats between healthcare providers patients, and their family members
                        </small>
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {this.state.tab === "setting" && (
                <div className="corporate-setting">
                  <form
                    onSubmit={this.handleUpdateCorporateSetting}
                    // this.updateCorporateName
                  >
                    <div className="row corp-setting">
                      <div className="main-sub-header" style={{ paddingTop: "50px" }}>
                        Corporate Setting
                      </div>
                      <div className="corporate-sub-header-2">Details</div>
                      <small style={{ marginTop: "10px" }}>Corporate Name</small>
                      <textarea
                        ref="corporateName"
                        className="form-control border-0 text-capitalize setting-textarea"
                        placeholder=""
                        defaultValue={this.state.address.name || ""}
                        disabled={this.state.nameIsUpdating}
                        required
                      />
                      <div className="corporate-sub-header-2">Business Address</div>
                      <small style={{ marginTop: "10px" }}>Address 1</small>
                      <textarea
                        ref="corporateAdd1"
                        className="form-control border-0 setting-textarea"
                        placeholder=""
                        defaultValue={this.state.address.business_address1 || ""}
                        required
                      />
                      <small style={{ marginTop: 5 }}>Address 2</small>
                      <textarea
                        ref="corporateAdd2"
                        className="form-control border-0 setting-textarea"
                        placeholder=""
                        defaultValue={this.state.address.business_address2 || ""}
                        required
                      />
                      <div className="row">
                        <span className="col corporate-setting-select">
                          <small className="">City</small>
                          <Select
                            className="form-control"
                            value={this.state.address.city || ""}
                            onChange={(e) =>
                              this.setState({
                                address: {
                                  ...address,
                                  city: e.target.value,
                                },
                              })
                            }
                          >
                            <option value="">Select city</option>
                            {city.map((item) => (
                              <option key={item.objectId} value={item.name}>
                                {item.name}
                              </option>
                            ))}
                          </Select>
                        </span>
                        <span className="col corporate-setting-select">
                          <small className="">State</small>
                          <Select
                            className="form-control"
                            value={this.state.address.state || ""}
                            onChange={(e) =>
                              this.setState({
                                address: {
                                  ...address,
                                  state: e.target.value,
                                },
                              })
                            }
                          >
                            <option value="">Select state</option>
                            {state.map((item) => (
                              <option key={item.objectId} value={item.objectId}>
                                {item.name}
                              </option>
                            ))}
                          </Select>
                        </span>
                        <span className="col corporate-setting-select">
                          <small className="">Country</small>
                          <Select
                            className="form-control"
                            value={this.state.address.country || ""}
                            onChange={(e) =>
                              this.setState({
                                address: {
                                  ...address,
                                  country: e.target.value,
                                },
                              })
                            }
                          >
                            <option value="">Select country</option>
                            {country.map((item) => (
                              <option key={item.objectId} value={item.objectId}>
                                {item.name}
                              </option>
                            ))}
                          </Select>
                        </span>
                        <br />
                        <span className="w-100"></span>
                        <span className="col-4">
                          <small className="">Postal Code</small>
                          <textarea
                            ref="corporatePostal"
                            className="form-control border-0 setting-textarea"
                            placeholder=""
                            defaultValue={this.state.address.postal_code || ""}
                            style={{
                              resize: "none",
                            }}
                            required
                          />
                        </span>
                      </div>
                      <div style={{ marginTop: 10, textAlign: "right" }}>
                        <button
                          type="submit"
                          title="Edit Medication"
                          className="btn btn-primary btn-md"
                          style={{ borderRadius: "12px", marginLeft: "auto" }}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              )}
              {this.state.tab === "members" && (
                <div className="corporate-members">
                  <div style={{ margin: "10px 0 0 0" }} className="corporate-patientHub-search">
                    <i className="fas fa-search"></i>
                    <input
                      onKeyDown={(e) => {
                        if (e.key === "Enter") this.findMember(e.target.value);
                      }}
                      // onChange={() => {}}
                      // onKeyPress={(e) => this.findMember(e.target.value)}
                      id="search"
                      placeholder="Search members"
                      type="search"
                      // value={term}
                    />
                  </div>
                  <div className="main-sub-header" style={{ marginTop: "10px" }}>
                    Corporate Team
                  </div>
                  <small className="main-sub-header-3">Owner</small>
                  <div className="corporate-members-table-row">
                    <div className="owner-img" style={{ display: "flex" }}>
                      <img src={imageURL} alt="Group Profile Picture" />
                      <div>
                        <p>{owner.displayName}</p>
                        <p>{owner.profession}</p>
                      </div>
                    </div>
                    <span className="">
                      <small className="badge members-badge badge-primary text-capitalize">
                        Super Admin
                        {/* {this.props.organization.owner.orgRole} */}
                      </small>
                    </span>
                    <span className="owner-auto-select">
                      <Select
                        className="member-auto-select"
                        value={owner.orgRole}
                        onChange={(e) => this.updateMemberAuthorization(owner, orgRole, "administrators")}
                      >
                        {/* {orgRole.map((index, key) => (
                          <option
                            key={key}
                            value={index}
                            onClick={() => {}}
                          >
                            {index}
                          </option>
                        ))} */}
                        <option value="">None</option>
                        <option value="physician">Prescriber</option>
                        <option value="editor">Editor</option>
                      </Select>
                    </span>
                    <span className="">
                      <div className="dropdown">
                        <button
                          className="btn dropdown-toggle"
                          type="button"
                          id="accountDropdownMenu"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          style={{ float: "right" }}
                        >
                          <i className="fas fa-ellipsis-v"></i>
                        </button>
                        <div className="dropdown-menu" aria-labelledby="accountDropdownMenu">
                          <button className="dropdown-item" type="button">
                            Action 1
                          </button>
                          <button className="dropdown-item" type="button">
                            Action 2
                          </button>
                        </div>
                      </div>
                    </span>
                  </div>
                  <div className="main-sub-header-2">Members</div>
                  <div className="corporate-members-navbar">
                    <ul className="nav nav-pills" role="tablist">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-toggle="pill"
                          href="#all"
                          onClick={() => this.setFilter("all")}
                        >
                          All Members
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#admins"
                          onClick={() => this.setFilter("admin")}
                        >
                          Administrators
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#regulars"
                          onClick={() => this.setFilter("member")}
                        >
                          Regular Members
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#guests"
                          onClick={() => this.setFilter("guest")}
                        >
                          Guests
                        </a>
                      </li>
                    </ul>
                    <div className="col">
                      <span className="members-add-action">
                        <button type="button" className="btn btn-primary btn-sm" onClick={this.openAddMemberModal}>
                          <i className="fas fa-plus"></i> add member
                        </button>
                      </span>
                    </div>
                  </div>
                  {/* {
                    <ShowMember 
                      members={this.props.organization.members}
                      admins={this.props.organization.administrators} 
                      guests={this.props.organization.guests}
                    />
                  } */}
                  <div className="corporate-members-table">
                    <div className="members-header corporate-members-table-row">
                      <span style={{ marginLeft: "40px" }}>Name</span>
                      <span>Corp. position</span>
                      <span>Authorization</span>
                      <span>
                        <span style={{ float: "right" }}>{filteredItems.length + 1}</span>
                      </span>
                    </div>
                    <div className="table-overflow">
                      {filteredItems.length > 0 &&
                        filteredItems.map((item, key) => (
                          <div className="corporate-members-table-row" id={key}>
                            <div className="members-img" style={{ display: "flex" }}>
                              <img
                                src={item.picture ? item.picture.url : defaultImageURL}
                                alt="Group Profile Picture"
                              />
                              <div>
                                <p>{item.displayName}</p>
                                <p>{item.profession}</p>
                              </div>
                            </div>
                            {/*  */}
                            <span>
                              <FilterBadge access={item.source} />
                            </span>
                            <span>
                              {item.access != "guest" && (
                                <SelectFormControl
                                  key={key}
                                  data={item}
                                  updateAutho={(selectedValue) => this.updateMemberAuthorization(selectedValue, item)}
                                />
                              )}
                            </span>
                            <span>
                              <div className="dropdown dropleft">
                                <button
                                  className="btn dropdown-toggle"
                                  type="button"
                                  id="memberDropdownMenu"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                  style={{ float: "right" }}
                                >
                                  <i className="fas fa-ellipsis-v"></i>
                                </button>
                                <div className="dropdown-menu" aria-labelledby="memberDropdownMenu">
                                  <button className="dropdown-item" type="button" onClick={this.removeMember}>
                                    <i className="fas fa-trash mr-1"></i>
                                    Remove
                                  </button>
                                  {item.access != "guest" && (
                                    <button className="dropdown-item" type="button">
                                      <i className="fas fa-user-tie mr-1"></i>
                                      {item.access == "admin" ? "Unassign Admin" : "Assign Admin"}
                                    </button>
                                  )}
                                </div>
                              </div>
                            </span>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
              {this.state.tab === "patientHub" && (
                <div className="corporate-patientHub">
                  <div style={{ margin: "10px 0 0 0" }} className="corporate-patientHub-search">
                    <i className="fas fa-search"></i>
                    <input
                      onKeyDown={(e) => {
                        if (e.key === "Enter") this.findMember(e.target.value);
                      }}
                      // onChange={() => {}}
                      // onKeyPress={(e) => this.findMember(e.target.value)}
                      id="search"
                      placeholder="Search patient hub"
                      type="search"
                      // value={term}
                    />
                  </div>
                  <div className="main-sub-header">Corp. Organization's Patient Hubs</div>
                  <div className="corporate-patientHub-navbar" style={{ marginTop: "20px" }}>
                    <ul className="nav nav-pills" role="tablist">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-toggle="pill"
                          href="#all"
                          onClick={() => {
                            this.setState({ filterPatient: "all" });
                          }}
                        >
                          All Hubs
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#admins"
                          onClick={() => {
                            this.setState({ filterPatient: "active" });
                          }}
                        >
                          Active
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#regulars"
                          onClick={() => {
                            this.setState({ filterPatient: "inactive" });
                          }}
                        >
                          Inactive
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#guests"
                          onClick={() => {
                            this.setState({ filterPatient: "cmm" });
                          }}
                        >
                          CCM
                        </a>
                      </li>
                    </ul>
                    <div className="col">
                      <span className="patientHub-add-action">
                        <button type="button" className="btn btn-primary btn-sm" onClick={this.openCreatePatientModal}>
                          <i className="fas fa-plus"></i> create pt. hub
                        </button>
                      </span>
                    </div>
                  </div>
                  <div className="corporate-patientHub-table">
                    <div className="members-header corporate-patientHub-table-row">
                      <span style={{ marginLeft: "40px" }}>Patient</span>
                      <span style={{ marginLeft: "20px" }}>Status</span>
                      <span>
                        {/* <span style={{float:"right"}}>
                        {members.length + 1}
                        </span> */}
                      </span>
                    </div>
                    <div className="patient-table-overflow">
                      {filteredHubs.length > 0 &&
                        filteredHubs.map((item, key) => (
                          <div className="corporate-patientHub-table-row" id={key}>
                            <div className="members-img" style={{ display: "flex" }}>
                              <img src={item.pic || defaultImage} alt="Group Profile Picture" />
                              <div>
                                <p>{item.name}</p>
                                <p>{moment(item.createdAt).format("MM/DD/YYYY")}</p>
                              </div>
                            </div>
                            <span>
                              <FilterHubStatus access={item.access} />
                            </span>
                            <span>
                              <div className="dropdown">
                                <button
                                  className="btn dropdown-toggle"
                                  type="button"
                                  id="memberDropdownMenu"
                                  data-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                  style={{ float: "right" }}
                                >
                                  <i className="fas fa-ellipsis-v"></i>
                                </button>
                                <div className="dropdown-menu" aria-labelledby="memberDropdownMenu">
                                  <button className="dropdown-item" type="button" onClick={this.removeMember}>
                                    <i className="fas fa-trash mr-1"></i>
                                    Remove
                                  </button>
                                  {item.access != "guest" && (
                                    <button className="dropdown-item" type="button">
                                      <i className="fas fa-user-tie mr-1"></i>
                                      {item.access == "admin" ? "Unassign Admin" : "Assign Admin"}
                                    </button>
                                  )}
                                </div>
                              </div>
                            </span>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              )}
              {this.state.tab === "subscription" && (
                <div className="corporate-subscription">
                  <div className="main-sub-header">Corp. Subscription</div>
                  <div className="corporate-subscription-navbar" style={{ marginTop: "20px" }}>
                    <ul className="nav nav-pills" role="tablist">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-toggle="pill"
                          href="#all"
                          onClick={() => {
                            this.setState({ filterSubs: "subscription" });
                          }}
                        >
                          Subscription
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#admins"
                          onClick={() => {
                            this.setState({ filterSubs: "payment" });
                          }}
                        >
                          Payment Method
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          data-toggle="pill"
                          href="#regulars"
                          onClick={() => {
                            this.setState({ filterSubs: "invoice" });
                          }}
                        >
                          Invoices
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div>
                    {this.state.filterSubs === "subscription" && (
                      <div className="corporate-subscription-table">
                        <div>Current Plan</div>
                        <div></div>
                        <div>Corp. Starter</div>
                        <div>
                          <small
                            className={"badge members-badge badge-primary"}
                            style={{ color: "white", marginRight: "10px" }}
                          >
                            Change Plan
                          </small>
                          <small className={"badge members-badge badge-danger"} style={{ color: "white" }}>
                            Cancel Plan
                          </small>
                        </div>
                      </div>
                    )}
                    {this.state.filterSubs === "payment" && <i>Payment method here</i>}
                    {this.state.filterSubs === "invoice" && <i>Invoice here</i>}
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      }
    }
  }

  _renderNoSubscription(message) {
    return (
      <>
        <h4 style={{ textAlign: "center" }} className="hc-primary-text">
          Corporate Account Subscription
        </h4>
        <p style={{ textAlign: "center", marginTop: "15px" }}>{message}</p>
      </>
    );
  }

  render() {
    if (this.props.organization) {
      if (this.props.organization.image) {
        if (this.props.organization.image.url !== this.state.profilePictureURL && !this.state.willUpload) {
          this.setState({
            profilePictureURL: this.props.organization.image.url,
          });
        }
      }
    }

    return (
      <div
        style={{
          height: "100vh",
          background: "#FFFFFF",
          // overflowY: "visible",
        }}
      >
        <ToastContainer />
        <AddMemberModal
          isOpen={this.state.openAddMemberModal}
          onClose={this.closeAddMemberModal.bind(this)}
          onSelect={this.addMember.bind(this)}
        />
        {this._renderLayout()}
        {this.state.openAddGuestModal && (
          <AddGuestModal
            from="organization"
            members={this.props.organization.guests}
            inviteGuest={this.addGuest.bind(this)}
            isOpen={this.state.openAddGuestModal}
            modalClose={this.closeAddGuestModal.bind(this)}
          />
        )}
        {this.state.openCreatePatientModal && (
          <CreatePatient
            isOpen={this.state.openCreatePatientModal}
            modalClose={this.closeCreatePatientModal.bind(this)}
          />
        )}
      </div>
    );
  }

  updateMemberAuthorization(orgRole, data, strRole) {
    // this.tempActionHandler("Updated Member role");
    console.log("orgRole", orgRole);
    console.log("data", data);
    // console.log('data', data)
    const role =
      strRole === "admin" || data.source === "member" || data.source === "admin" ? "administrators" : "member";
    this.props.setOrganizationRole({
      data,
      organization: this.props.organization,
      strRole: orgRole,
    });
  }

  //Filter test members
  filterMembers(access) {
    const filterMember = testMembers.filter(function(member) {
      return member.access == access;
    });
    this.setState({ members: filterMember });
  }

  findMember(term) {
    this.setState({ searchKey: term });
  }
}

const SelectFormControl = ({ data, updateAutho }) => {
  return (
    <Select className="member-auto-select" value={data.orgRole} onChange={(e) => updateAutho(e.target.value)}>
      <option value="">None</option>
      <option value="physician">Prescriber</option>
      <option value="editor">Editor</option>
    </Select>
  );
};

const FilterBadge = ({ access }) => {
  const badge = {};
  switch (access) {
    case "admin":
      {
        badge.class = "badge-primary";
        badge.text = "Administrator";
        badge.color = "#FF7377";
      }
      break;
    case "member":
      {
        badge.class = "badge-success";
        badge.text = "Member";
        badge.color = "#90EE90";
      }
      break;
    case "guest":
      {
        badge.class = "badge-secondary";
        badge.text = "Guest";
      }
      break;
  }
  return (
    <small className={"badge members-badge " + badge.class} style={{ backgroundColor: badge.color, color: "white" }}>
      {badge.text}
    </small>
  );
};

const FilterHubStatus = ({ access }) => {
  const badge = {};
  switch (access) {
    case "admin" || "member":
      {
        badge.class = "badge-primary";
        badge.text = "Active";
        badge.color = "#90EE90";
      }
      break;
    case "guest":
      {
        badge.class = "badge-success";
        badge.text = "Inactive";
        badge.color = "#FF7377";
      }
      break;
  }
  return (
    <small className={"badge members-badge " + badge.class} style={{ backgroundColor: badge.color, color: "white" }}>
      {badge.text}
    </small>
  );
};

const ShowMember = ({ members, admins, guests }) => {
  if (filter == "admin") {
    members = [];
    guests = [];
  }
  if (filter == "member") {
    admins = [];
    guests = [];
  }
  if (filter == "guest") {
    admins = [];
    members = [];
  }
  admins = [];
  let allMembers = members.concat(admins, guests ? guests : []);
  // console.log(allMembers);
  // let filterAllMembers = [...new Map(allMembers.map((i) => [i.objectId, i]).values())];
  // console.log(filterAllMembers);
  return allMembers.map((member) => {
    return <SearchItem key={member.objectId} member={member} orgRole={orgRole} />;
  });
};

const mapStateToProps = (state) => ({
  organization: state.session.organization,
  organizationFetchStatus: state.session.organizationFetchStatus,
  organizationGroups: state.session.organizationGroups,
  revenueCatSubscriber: state.session.revenueCatSubscriber,
});
export default connect(mapStateToProps, {
  fetchOrganization,
  createOrganization,
  updateOrganizationName,
  updateOrganizationProfile,
  addMembersToOrganization,
  addGuestsToOrganization,
  removeMembersFromOrganization,
  removeGuestsFromOrganization,
  addAdminsToOrganization,
  removeAdminsFromOrganization,
  fetchOrganizationGroups,
  addGroupsToOrganization,
  removeGroupsFromOrganization,
  setOrganizationRole,
  createThread,
  addOrgEmail,
  removeOrgEmail,
  fetchSubscriber,
  organizationDashboard,
  patientHubs,
  modifyOrganization,
})(CorporateSetting);
